var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M30.77 32c-.159.001-.317-.03-.465-.09-.148-.06-.282-.15-.396-.262l-6.118-6.116c-1.968 1.525-4.443 2.244-6.922 2.009-2.478-.236-4.774-1.407-6.42-3.275-1.645-1.868-2.518-4.294-2.438-6.782.08-2.489 1.105-4.853 2.866-6.613 1.762-1.76 4.128-2.781 6.616-2.858 2.489-.077 4.913.798 6.78 2.446 1.866 1.648 3.034 3.945 3.266 6.424.232 2.479-.488 4.953-2.016 6.919l6.116 6.116c.113.112.203.245.264.392.062.147.093.305.092.464 0 .161-.031.32-.093.47-.061.148-.151.284-.265.398-.114.114-.25.204-.399.265-.148.062-.307.093-.468.093zM17.788 10.454c-1.7 0-3.346.59-4.66 1.667-1.314 1.078-2.212 2.578-2.544 4.245-.332 1.667-.075 3.396.726 4.895.8 1.499 2.097 2.674 3.667 3.324 1.57.65 3.317.736 4.943.243 1.626-.494 3.03-1.536 3.975-2.949.944-1.413 1.37-3.109 1.203-4.8-.167-1.691-.915-3.273-2.116-4.474-.68-.686-1.49-1.229-2.381-1.6-.892-.37-1.848-.559-2.813-.556v.005z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.077696d454e854fd332e9275af3dc31c.svg";
export { ForwardRef as ReactComponent };